import React from 'react';
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { Grid, FormControlLabel, FormGroup, Checkbox, RadioGroup, Radio, TextField, InputAdornment, IconButton, Typography } from '@material-ui/core';
import Select from 'react-select';
import styles from '../analytics/analytics.module.css';
import commonStyles from './common.module.css';
import AirlineType from '../../models/AirlineType';
import ForwarderModel from '../../models/ForwarderAwb';
import DeliveryCompany from '../../models/DeliveryCompany';
import { AnalyDetail, filterOptions, UserData } from '../../models/Analytics';
import { TimePicker } from '@material-ui/pickers';
import { Moment } from 'moment';
import ClearIcon from '@material-ui/icons/Clear';
import file from '../../assets/excelFile.svg'


const useStyles = (theme: Theme) =>

  createStyles({
    inputHour: {
      paddingTop: '7px',
      paddingBottom: '7px',
    },
    numberInput: {
      '&::-webkit-inner-spin-button': {
        WebkitAppearance: 'auto',
        margin: 0,
      },
      '&::-webkit-outer-spin-button': {
        WebkitAppearance: 'auto',
        margin: 0,
      },
    },
  });

interface FilterProps {
  classes: any;
  filterOptions: filterOptions
  pickUp?: boolean;
  dropOff?: boolean;
  error?: boolean;
  appt?: boolean;
  carrCheck?: boolean;
  carr?: string;
  report?: string;
  fwd_id?: number;
  trk_cmp?: number;
  drv_name?: string;
  scr_name?: string;
  gha_id?: number;
  entity?: string;
  rank_by?: string;
  startTime?: Moment;
  endTime?: Moment;
  airlines?: AirlineType[];
  forwarders?: ForwarderModel[];
  companies?: DeliveryCompany[];
  drivers?: Array<string>;
  screeners?: AnalyDetail[];
  users?: UserData[];
  handleChangeProcess?: (type: string, value: boolean) => void;
  handleChangeCarriers?: (type: string, value: boolean) => void;
  handleChangeOption?: (type: string, event: any) => void;
  handleChangeTime?: (type: string, event: any) => void;
  handleExport?: (type: string) => void;
  exceedHours?: number;
  handleExceedHoursChange?: (value: any) => void;
}

interface Option {
  value?: number | string;
  label: string;
};

const Filter = (props: FilterProps) => {

  const { classes } = props;

  const airlinesOptions: Array<JSX.Element> | undefined = props.airlines && props.airlines.map((item: AirlineType, index: number) => {
    return (
      <FormControlLabel
        control={
          <Checkbox
            name="carr"
            classes={{
              root: styles.filterCheckbox,
              checked: styles.filterCheckbox
            }}
            checked={props.carr && props.carr.includes(item.iata_code) || false}
            value={item.iata_code}
            onChange={(e, v) => {
              props.handleChangeCarriers && props.handleChangeCarriers(e.target.value, v)
            }}
            size="small"
          />
        }
        label={item.iata_code}
        className={styles.carrierCheckbox}
      />
    );
  });

  const FwdOptions: Array<Option> = props.forwarders && props.forwarders.map((item: ForwarderModel) => (
    {
      value: item.id,
      label: item.name
    }
  )) || [];

  const getFwdValue = (): Option => {
    const value: Array<Option> = FwdOptions.filter((fwd: any) => fwd.value === props.fwd_id);
    return value[0];
  }
  const FwdValue: any = props.fwd_id ? getFwdValue() : null;

  const CompaniesOptions: Array<Option> = props.companies && props.companies.map((item: DeliveryCompany) => (
    {
      value: item.id,
      label: item.name
    }
  )) || [];

  const getCompaniesValue = (): Option => {
    const value: Array<Option> = CompaniesOptions.filter((cmp: any) => cmp.id === props.trk_cmp);
    return value[0];
  }
  const CompaniesValue: any = props.trk_cmp ? getCompaniesValue() : null;

  const DriverOptions: Array<Option> = props.drivers && props.drivers.map((item: string) => (
    {
      value: item,
      label: item
    }
  )) || [];

  const getDriverValue = (): Option => {
    const value: Array<Option> = DriverOptions.filter((drv: any) => drv === props.drv_name);
    return value[0];
  }
  const drvValue: any = props.drv_name ? getDriverValue() : null;


  const UserOptions: Array<Option> = props.users && props.users.map((item: UserData) => (
    {
      value: item.id,
      label: item.first_name + ' ' + item.last_name
    }
  )) || [];

  const getUserValue = (): Option => {
    const value: Array<Option> = UserOptions.filter((fwd: any) => fwd.value === props.gha_id);
    return value[0];
  }
  const UserValue: any = props.gha_id ? getUserValue() : null;

  const ScreenerOptions: Array<Option> = props.screeners && props.screeners.map((item: any) => (
    {
      value: item.name,
      label: item.name
    }
  )) || [];

  const getScreenerValue = (): Option => {
    const value: Array<Option> = ScreenerOptions.filter((scr: any) => scr.value === props.scr_name);
    return value[0];
  }
  const scrValue: any = props.scr_name ? getScreenerValue() : null;

  const CustomStyle = {
    control: (baseStyles: any, state: { isFocused: any; }) => ({
      ...baseStyles,
      borderColor: state.isFocused ? 'black' : 'none',
      fontSize: '13px',
      minHeight: '28px !important',
      height: '28px !important',
      boxShadow: 'none',
    }),
    container: (baseStyles: any) => ({
      ...baseStyles,
      borderRadius: 'var(--ip-br)',
      height: '28px !important',
      backgroundColor: 'white',
    }),
    indicatorsContainer: (baseStyles: any) => ({
      ...baseStyles,
      height: '28px !important',
    }),
    valueContainer: () => ({
      padding: '0 8px',
    }),
    singleValue: (baseStyles: any) => ({
      ...baseStyles,
      maxWidth: 'calc(100% - 75px)',
    }),
    option: (base: any, state: { isSelected: any; isDisabled: any; isFocused: any }) => ({
      ...base,
      backgroundColor: state.isDisabled
        ? 'transparent'
        : state.isSelected
          ? 'lightgrey'
          : state.isFocused ? 'lightgrey'
            : undefined,
      color: state.isDisabled
        ? 'lightgrey'
        : state.isSelected
          ? 'black'
          : state.isFocused ? 'black'
            : 'black',
      fontSize: '13px',
      cursor: state.isDisabled ? 'not-allowed' : 'pointer',
    })
  };

  return (
    <div className={`${styles.filterWrapperOuter}`}>
      <Grid container spacing={2} className={`${styles.customerGridItems} ${styles.filterContainer}`}>
        <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className={`${styles.filterWrapper}`}>
          <p className={`${commonStyles.my0}`}>Report Filters</p>
        </Grid>
        <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className={`${styles.filterWrapper}`}>
          <p className={`${styles.filterTitle}`}>Time Filter</p>
          <div className={`${styles.gridItem} ${commonStyles.inputLabelWrapper}`}>
            <label className={`${commonStyles.inputLabel} ${commonStyles.whiteLabel}`}>
              Exclude orders exceeding
            </label>
            <div className={`${commonStyles.fvMiddle} ${commonStyles.gap10}`}>
            <TextField
              type="number"
              fullWidth
              value={props.exceedHours || ''}
              onChange={(e) => {
                const value = e.target.value === '' ? undefined : parseInt(e.target.value);
                if (value === undefined || (!isNaN(value) && value >= 0)) {
                  props.handleExceedHoursChange && props.handleExceedHoursChange(value);
                }
              }}
              variant="outlined"
              size="small"
              className={styles.filterInput}
              InputProps={{
                classes: { 
                  root: classes.numberInput,
                  input: classes.inputHour 
                },
                endAdornment: (
                  <InputAdornment position="end">
                      <IconButton
                        size="small"
                        onClick={() => props.handleExceedHoursChange && props.handleExceedHoursChange(undefined)}
                        disabled={!props.exceedHours}>
                        <ClearIcon style={{ fontSize: 'inherit', opacity: props.exceedHours ? 1: 0.3 }}  />
                      </IconButton>
                  </InputAdornment>
                ),
              }}
              inputProps={{
                min: 0,
              }}
            />
            <Typography variant="body2" component="span">Hours</Typography>
            </div>
          </div>
        </Grid>
        {props.filterOptions.process && (<Grid item xl={12} lg={12} md={12} sm={12} xs={12} className={`${styles.filterWrapper}`}>
          <p className={`${styles.filterTitle}`}>Process</p>
          <FormGroup row className={`${styles.customerFormGroup}`}>
            <FormControlLabel
              control={
                <Checkbox
                  name="pickUp"
                  checked={props.pickUp}
                  classes={{
                    root: styles.filterCheckbox,
                    checked: styles.filterCheckbox
                  }}
                  onChange={(e, v) => {
                    props.handleChangeProcess && props.handleChangeProcess(e.target.name, v)
                  }}
                  size="small"
                />
              }
              label="Pick Ups"
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="dropOff"
                  checked={props.dropOff}
                  classes={{
                    root: styles.filterCheckbox,
                    checked: styles.filterCheckbox
                  }}
                  onChange={(e, v) => {
                    props.handleChangeProcess && props.handleChangeProcess(e.target.name, v)
                  }}
                  size="small"
                />
              }
              label="Drop Offs"
            />
            {props.filterOptions.cust_err && (<FormControlLabel
              control={
                <Checkbox
                  name="error"
                  checked={props.error}
                  classes={{
                    root: styles.filterCheckbox,
                    checked: styles.filterCheckbox
                  }}
                  onChange={(e, v) => {
                    props.handleChangeProcess && props.handleChangeProcess(e.target.name, v)
                  }}
                  size="small"
                />
              }
              label="Exclude Customer Errors" />)}
            {props.filterOptions.appt && (<FormControlLabel
              control={
                <Checkbox
                  name="appt"
                  checked={props.appt}
                  classes={{
                    root: styles.filterCheckbox,
                    checked: styles.filterCheckbox
                  }}
                  onChange={(e, v) => {
                    props.handleChangeProcess && props.handleChangeProcess(e.target.name, v)
                  }}
                  size="small"
                />
              }
              label="Show Apointments Only"
            />)}
          </FormGroup>
        </Grid>)}

        {props.filterOptions.carriers && (<Grid item xl={12} lg={12} md={12} sm={12} xs={12} className={`${styles.filterWrapper}`}>
          <p className={`${styles.filterTitle} ${commonStyles.fSpaceBtw} ${commonStyles.gap10}`}>Handled Carriers
            <FormControlLabel
              control={
                <Checkbox
                  name="carrCheck"
                  checked={props.carrCheck}
                  classes={{
                    root: styles.filterCheckbox,
                    checked: styles.filterCheckbox
                  }}
                  onChange={() => {
                    props.handleChangeCarriers && props.handleChangeCarriers('GLOABL', !props.carrCheck)
                  }}
                  size="small"
                />
              }
              className={`${commonStyles.mr0} ${commonStyles.mbNeg12} ${commonStyles.mtNeg12}`}
              label="ALL"
            />
          </p>
          <FormGroup row className={`${styles.customerFormGroup}`}>
            {airlinesOptions}
          </FormGroup>
        </Grid>)}

        {props.filterOptions.forwarders && (<Grid item xl={12} lg={12} md={12} sm={4} xs={12} className={`${styles.filterWrapper}`}>
          <p className={`${styles.filterTitle}`}>Forwarders</p>
          <div className={`${styles.gridItem} ${commonStyles.inputLabelWrapper}`}>
            <label className={`${commonStyles.inputLabel} ${commonStyles.whiteLabel}`}> Enter Forwarder </label>
            <Select
              value={FwdValue}
              options={FwdOptions}
              onChange={(event: any) => {
                props.handleChangeOption && props.handleChangeOption('fwd_id', event ? event : { value: 0 })
              }}
              isClearable
              styles={CustomStyle}
            />
          </div>
        </Grid>)}

        {props.filterOptions.company && (<Grid item xl={12} lg={12} md={12} sm={4} xs={12} className={`${styles.filterWrapper}`}>
          <p className={`${styles.filterTitle}`}>Trucking Company</p>
          <div className={`${styles.gridItem} ${commonStyles.inputLabelWrapper}`}>
            <label className={`${commonStyles.inputLabel} ${commonStyles.whiteLabel}`}> Enter Trucking Company </label>
            <Select
              value={CompaniesValue}
              options={CompaniesOptions}
              onChange={(event: any) => {
                props.handleChangeOption && props.handleChangeOption('trk_cmp', event ? event : { value: 0 })
              }}
              isClearable
              styles={CustomStyle}
            />
          </div>
        </Grid>)}

        {props.filterOptions.driver && (<Grid item xl={12} lg={12} md={12} sm={4} xs={12} className={`${styles.filterWrapper}`}>
          <p className={`${styles.filterTitle}`}>Specific Truck Driver</p>
          <div className={`${styles.gridItem} ${commonStyles.inputLabelWrapper}`}>
            <label className={`${commonStyles.inputLabel} ${commonStyles.whiteLabel}`}> Enter Driver’s Name </label>
            <Select
              value={drvValue}
              options={DriverOptions}
              onChange={(event: any) => {
                props.handleChangeOption && props.handleChangeOption('drv_name', event ? event : { value: '' })
              }}
              isClearable
              styles={CustomStyle}
            />
          </div>
        </Grid>)}

        {props.filterOptions.gha && (<Grid item xl={12} lg={12} md={12} sm={4} xs={12} className={`${styles.filterWrapper}`}>
          <p className={`${styles.filterTitle}`}>Specific GHA Employee</p>
          <div className={`${styles.gridItem} ${commonStyles.inputLabelWrapper}`}>
            <label className={`${commonStyles.inputLabel} ${commonStyles.whiteLabel}`}> Enter Employee Name </label>
            <Select
              value={UserValue}
              options={UserOptions}
              onChange={(event: any) => {
                props.handleChangeOption && props.handleChangeOption('gha_id', event ? event : { value: 0 })
              }}
              isClearable
              styles={CustomStyle}
              menuPlacement="top"
            />
          </div>
        </Grid>)}

        {props.filterOptions.entity && (<Grid item xl={12} lg={12} md={12} sm={4} xs={12} className={`${styles.filterWrapper}`}>
          <p className={`${styles.filterTitle}`}>Entity</p>
          <RadioGroup
            row
            aria-label="entity"
            name="entity"
            className={`${styles.entityRadioGroup}`}
          >
            <FormControlLabel
              checked={props.entity == 'forwarder' ? true : false}
              onClick={() => {
                props.handleChangeOption && props.handleChangeOption('entity', 'forwarder')
              }}
              control={
                <Radio
                  value="forwarder"
                  size="small"
                  classes={{
                    root: styles.filterCheckbox,
                    checked: styles.filterCheckbox
                  }}
                />
              }
              label="Forwarders"
            />
            <FormControlLabel
              checked={props.entity == 'company' ? true : false}
              onClick={() => {
                props.handleChangeOption && props.handleChangeOption('entity', 'company')
              }}
              control={
                <Radio
                  value="tucking_co"
                  size="small"
                  classes={{
                    root: styles.filterCheckbox,
                    checked: styles.filterCheckbox
                  }}
                />
              }
              label="Trucking Company"
            />
          </RadioGroup>
        </Grid>)}

        {props.filterOptions.rank_by && (<Grid item xl={12} lg={12} md={12} sm={8} xs={12} className={`${styles.filterWrapper}`}>
          <p className={`${styles.filterTitle}`}>Rank By</p>
          <RadioGroup
            row
            aria-label="rank by"
            name="rank by"
            className={`${styles.entityRadioGroup}`}>
            <FormControlLabel
              checked={props.rank_by == 'wgt' ? true : false}
              onClick={() => {
                props.handleChangeOption && props.handleChangeOption('rank_by', 'wgt')
              }}
              control={
                <Radio
                  value="wgt"
                  size="small"
                  classes={{
                    root: styles.filterCheckbox,
                    checked: styles.filterCheckbox
                  }}
                />
              }
              label="Tonnage (Actual Weight)"
            />
            <FormControlLabel
              checked={props.rank_by == 'pcs' ? true : false}
              onClick={() => {
                props.handleChangeOption && props.handleChangeOption('rank_by', 'pcs')
              }}
              control={
                <Radio
                  value="pcs"
                  size="small"
                  classes={{
                    root: styles.filterCheckbox,
                    checked: styles.filterCheckbox
                  }}
                />
              }
              label="Pieces"
            />
            <FormControlLabel
              checked={props.rank_by == 'awbs' ? true : false}
              onClick={() => {
                props.handleChangeOption && props.handleChangeOption('rank_by', 'awbs')
              }}
              control={
                <Radio
                  value="awbs"
                  size="small"
                  classes={{
                    root: styles.filterCheckbox,
                    checked: styles.filterCheckbox
                  }}
                />
              }
              label="Number of Awbs"
            />
            <FormControlLabel
              checked={props.rank_by == 'orders' ? true : false}
              onClick={() => {
                props.handleChangeOption && props.handleChangeOption('rank_by', 'orders')
              }}
              control={
                <Radio
                  value="orders"
                  size="small"
                  classes={{
                    root: styles.filterCheckbox,
                    checked: styles.filterCheckbox
                  }}
                />
              }
              label="Number of Orders"
            />
          </RadioGroup>
        </Grid>)}
        {props.filterOptions.report && (
          <Grid item xl={12} lg={12} md={12} sm={4} xs={12} className={`${styles.filterWrapper}`}>
            <p className={`${styles.filterTitle}`}>Generate Report Based On</p>
            <RadioGroup
              row
              aria-label=""
              name=""
              className={`${styles.entityRadioGroup}`}
            >
              <FormControlLabel
                checked={props.report == 'awbs' ? true : false}
                onClick={() => {
                  props.handleChangeOption && props.handleChangeOption('report', 'awbs')
                }}
                control={
                  <Radio
                    value="awbs"
                    size="small"
                    classes={{
                      root: styles.filterCheckbox,
                      checked: styles.filterCheckbox
                    }}
                  />
                }
                label="Awbs"
              />
              <FormControlLabel
                checked={props.report == 'pcs' ? true : false}
                onClick={() => {
                  props.handleChangeOption && props.handleChangeOption('report', 'pcs')
                }}
                control={
                  <Radio
                    value="pcs"
                    size="small"
                    classes={{
                      root: styles.filterCheckbox,
                      checked: styles.filterCheckbox
                    }}
                  />
                }
                label="Pcs"
              />
              <FormControlLabel
                checked={props.report == 'wgt' ? true : false}
                onClick={() => {
                  props.handleChangeOption && props.handleChangeOption('report', 'wgt')
                }}
                control={
                  <Radio
                    value="wgt"
                    size="small"
                    classes={{
                      root: styles.filterCheckbox,
                      checked: styles.filterCheckbox
                    }}
                  />
                }
                label="Wgt"
              />
            </RadioGroup>
          </Grid>
        )}
        {props.filterOptions.screener && (
          <Grid item xl={12} lg={12} md={12} sm={4} xs={12} className={`${styles.filterWrapper}`}>
            <p className={`${styles.filterTitle}`}>Specific Screener</p>
            <div className={`${styles.gridItem} ${commonStyles.inputLabelWrapper}`}>
              <label className={`${commonStyles.inputLabel} ${commonStyles.whiteLabel}`}> Enter Screener Name </label>
              <Select
                value={scrValue}
                options={ScreenerOptions}
                onChange={(event: any) => {
                  props.handleChangeOption && props.handleChangeOption('scr_name', event ? event.value : '')
                }}
                isClearable
                styles={CustomStyle}
              />
            </div>
          </Grid>
        )}
        {props.filterOptions.time && (
          <Grid item xl={12} lg={12} md={12} sm={4} xs={12} className={`${styles.filterWrapper}`}>
            <p className={`${styles.filterTitle}`}>Time of Day (Shifts)</p>
            <div className={`${commonStyles.dFlex} ${commonStyles.gap10}`}>
              <div className={`${styles.gridItem} ${commonStyles.inputLabelWrapper}`}>
                <label className={`${commonStyles.inputLabel} ${commonStyles.whiteLabel}`}> From </label>
                <TimePicker
                  format='HH:mm'
                  onChange={(time) => props.handleChangeTime && props.handleChangeTime('startTime', time)}
                  value={props.startTime}
                  InputProps={{
                    disableUnderline: true
                  }}
                />
              </div>
              <div className={`${styles.gridItem} ${commonStyles.inputLabelWrapper}`}>
                <label className={`${commonStyles.inputLabel} ${commonStyles.whiteLabel}`}> To </label>
                <TimePicker
                  format='HH:mm'
                  onChange={(time) => props.handleChangeTime && props.handleChangeTime('endTime', time)}
                  value={props.endTime}
                  // minTime={props.startTime}   
                  InputProps={{
                    disableUnderline: true
                  }}
                />
              </div>
            </div>
          </Grid>
        )}

        {props.filterOptions.export && (<Grid item xl={12} lg={12} md={12} sm={4} xs={12} className={`${styles.filterWrapper}`}>
          <div className={`${styles.filterTitle} ${commonStyles.fSpaceBtw}`}>
            <span>Data Dump To Excel</span>
            <div className={`${styles.whiteFileImg}`} onClick={() => props.handleExport && props.handleExport('all')}>
              <img src={file} alt="file" />
            </div>
          </div>
        </Grid>)}
      </Grid>
    </div>
  );
};

export default withStyles(useStyles)(Filter);